import React from 'react'

const SmokingList = () => {
    return (
        <>
            <div className="row">
                <div className="col-12">
                    <div className="accordion-list">
                        <ul>
                            <li><i class="fa-solid fa-circle-check"></i>Cigarette brand(s)</li>
                            <li><i class="fa-solid fa-circle-check"></i>Cigarettes / day</li>
                            <li><i class="fa-solid fa-circle-check"></i>Further tobacco products</li>
                            <li><i class="fa-solid fa-circle-check"></i>Electronic cigarette</li>
                            <li><i class="fa-solid fa-circle-check"></i>Applied methods for smoking cessation</li>
                        </ul>
                    </div>
                </div>
            </div>
        </>
    )
}

export default SmokingList